import { Timestamp } from 'firebase/firestore';
import moment from 'moment';

import ReportRepository from '@src/repositories/ReportRepository';

class ReportService {
  constructor() {
    this.repository = new ReportRepository();
  }

  #momentDataToTimestamp(markData) {
    const convertMomentToISO = obj => {
      if (obj === null || obj === undefined) return obj;

      if (obj instanceof moment) return Timestamp.fromMillis(obj.valueOf());

      if (Array.isArray(obj)) return obj;

      if (typeof obj === 'object') {
        const converted = {};
        Object.keys(obj).forEach(key => {
          converted[key] = convertMomentToISO(obj[key]);
        });
        return converted;
      }

      return obj;
    };

    return convertMomentToISO(markData);
  }

  async editWorkJourneyMark(markData, organizationId) {
    const cleanMarkData = this.#momentDataToTimestamp(markData);
    return this.repository.editWorkJourneyMark(cleanMarkData, organizationId);
  }
}

export default ReportService;
